/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Powered by Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Powered by AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Content is based on your permissions, and its quality may vary',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Content quality may vary',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Information',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence Logo',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Back',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Cancel',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Cancel',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Cancel',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Bad response',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback sent',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Good response',
  'fabric.editor.ai.config.item.action.copyResponse': 'Copy',
  'fabric.editor.ai.config.item.action.responseCopied': 'Copied!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Copied to clipboard',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Retry',
  'fabric.editor.ai.experience-application.documentInsertError':
    "We're having trouble inserting the response. Close the dialog and try again.",
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again.",
  'fabric.editor.ai.experience.apiError': 'We couldn’t get a response, please try again.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.footerRightText.agents': 'Powered by Rovo',
  'fabric.editor.ai.experience.inputTooShortError':
    'The content is too short to summarize. Please add more and try again.',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Generating',
  'fabric.editor.ai.experience.previewScreenLabel': 'Preview',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Tell Agent to write anything or choose from the below',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo Logo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.actionableFeedback':
    'Try "Provide concise, specific and actionable feedback on this draft from an editor\'s perspective"',
  'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.beginnerAudience':
    'Try "Make this content suitable for a beginner audience"',
  'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.missingInformation':
    'Try "Identify and list any missing information needed"',
  'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.openQuestions':
    'Try "Identify and list any open questions"',
  'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.readerQuestions':
    'Try "Create a list of questions a reader might have about this content"',
  'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.stepsWorkflow':
    'Try "Convert this into a step-by-step workflow"',
  'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.timeline':
    'Try "Convert this information into a timeline with dates"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.actionCheckboxes':
    'Try "Extract the key actionables as action checkboxes"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.actionPlan':
    'Try "Create an action plan based on these notes"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.bulletListSummarize':
    'Try "Summarize the selected text into bullet points"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.decisionLog':
    'Try "Convert this discussion into a decision log"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.dynamicEngaging':
    'Try "Make this content more engaging and dynamic"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.formattedTable':
    'Try "Turn this list into a formatted table"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.generateFaqs':
    'Try "Generate FAQs from the above information"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.highlightRisks':
    'Try "Highlight the key risks in this plan"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.improveClarity':
    'Try "Improve the clarity of this section"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.keyPointsTodo':
    'Try "Summarize the key points and create a to-do list"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.simplifyJargon':
    'Try "Simplify this technical jargon for a general audience"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.termsGlossary':
    'Try "Create a glossary of terms from this document"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.translateSpanish':
    'Try "Translate to Spanish"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.adoptRole':
    'Tip: Ask AI to adopt a role, e.g. "Act as a reviewer and critique this content"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.changeToneProfessional':
    'Tip: Need a formal writing style? Use "Change tone to professional"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.codeSnippets':
    'Tip: You can ask AI to optimize or comment on code snippets',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.combineCommands':
    'Tip: To get more done, combine commands: "Summarize and translate into French"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.confluenceUrls':
    'Tip: Want to use info from Confluence? Paste a URL here so AI can reference it',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.detailedPrompts':
    'Tip: The more detailed your prompt, the better the answer',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.detectInconsistencies':
    'Tip: Try "Detect inconsistencies" to ensure your content is consistent and error-free',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.findActionItems':
    'Tip: Use "Find Action Items" to let AI find tasks and create checkboxes next to them',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.focusText':
    'Tip: Select the text you want AI to focus on',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.formattingRequests':
    'Tip: You can request formatted outputs like tables or lists',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.generateOutline':
    'Tip: Try "Generate an outline" for a step by step summary of content',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.improveWriting':
    'Tip: Use "Improve writing" to enhance clarity and flow',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.keyThemes':
    'Tip: Ask AI to "Identify key themes" in your text',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.makeShorter':
    'Tip: Want a concise summary? Try "Make shorter"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.mentionAudience':
    'Mention your audience so AI can adjust the writing level, e.g. "Explain to investors"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.metaphorsAnalogies':
    'Tip: Try "Generate metaphors or analogies" to make complex ideas more relatable',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.pasteSmartLinks':
    'Tip: You can paste Jira and Confluence links here',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.questionAnswerFormat':
    'Tip: Generate an FAQ section by using "Convert to Q&A format"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.smartLinksAsk':
    'Tip: Ask AI about any Jira or Confluence link you paste here',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.specificAreaChanges':
    'Tip: Need changes in a specific area? Highlight it before prompting',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.styleGuidelines':
    'Tip: Set clear style guidelines, e.g. "Use a formal tone"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.summarize':
    'Tip: Ask AI to "Summarize" to make content more succinct',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.todoList':
    'Tip: Generate a to-do list from notes using "Create action checkboxes"',
  'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.translateLanguage':
    'Tip: Need a translation? Try "Translate to Australian English"',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Back',
  'fabric.editor.ai.screens.discard.discardLabel': 'Discard',
  'fabric.editor.ai.screens.discard.warningIconLabel': 'Warning',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Error',
  'fabric.editor.ai.screens.error.cancelLabel': 'Cancel',
  'fabric.editor.ai.screens.error.retryLabel': 'Try again',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Warning',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Live updating content:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Generating icon',
  'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Cancel',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Tell AI what to do next',
  'fabric.editor.ai.screens.preview.discardLabel': 'Discard',
  'fabric.editor.ai.screens.preview.disclaimer': 'Information quality may vary.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Learn why',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Clear',
  'fabric.editor.ai.screens.preview.header.edit': 'Edit prompt',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Edit',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Ask {agentName} what to do next',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence Logo',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Submit',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Send to AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} - Selected',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Remove',
  'fabric.editor.ai.shared.aiProactiveCallToAction': 'Suggested edits',
  'fabric.editor.ai.shared.aiProactiveDescriptor': 'Suggested edits',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Writing assistant',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Let Atlassian Intelligence assist your writing',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Write',
  'fabric.editor.ai.shared.betaLabel': 'Beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NEW',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Tell AI',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Tell Agent',
};
